import { api, ReactQueryOptions, RouterInputs } from '@api'
import { staleTimeIndex } from '@specs/constants'

type optionsType = ReactQueryOptions['ToyManager']['getSingle']
type inputType = RouterInputs['ToyManager']['getSingle']

export const useGetToy = (input: inputType, options?: optionsType) =>
    api.ToyManager.getSingle.useQuery(input, {
        queryKey: ['ToyManager.getSingle', input],
        staleTime: 60 * 60 * 1000 * staleTimeIndex, // 1 hour
        ...options,
    })
